
import apiClient from './client';

export const AuditLogsAxiosInstance = apiClient;